// @flow

import queryString from 'query-string';
import { artist as ARTIST_ENUM } from 'Enum';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';

type Props = {
  search: string,
  isGalleryMode?: boolean,
};

/**
 * useGallerySwitch
 *
 * @param {Props} props
 * @returns {Function}
 */
export function useGallerySwitch({ search, isGalleryMode = false }: Props): Function {
  const { page, sort, ...rest } = queryString.parse(search) || {};
  const parsedPage = parseInt(page, 10);
  const requestedPage = parsedPage > 0 ? parsedPage : 1;
  const requestedSort = Object.keys(ARTIST_ENUM.art.rank).some(
    (key) => ARTIST_ENUM.art.rank[key] === sort,
  )
    ? sort
    : ARTIST_ENUM.art.rank.RANKING_ARTIST;
  const filterParams = {
    ...rest,
    ...(requestedPage > 1 ? { page: requestedPage } : {}),
    ...(requestedSort !== ARTIST_ENUM.art.rank.RANKING_ARTIST ? { sort: requestedSort } : {}),
  };

  return function generateUrls({ detailId, id, alias, artistSubpageKey }) {
    return {
      listUrl: isGalleryMode
        ? UrlAssembler.artistSubpage(artistSubpageKey, id, alias, {
            search: filterParams || {},
          })
        : null,
      detailUrl:
        !isGalleryMode && detailId
          ? UrlAssembler.artistSubpage(artistSubpageKey, id, alias, {
              search: filterParams || {},
              hash: { detail: detailId },
            })
          : null,
    };
  };
}
